'use strict';

/**
 * Module dependencies
 */
var angular = require('angular');

module.exports = angular
  .module('app.core-utilities.dynamic-header-buttons', [])
  /*.service('HeaderButtonsService', require('./HeaderButtonsService.js'))
  .service('ViewHeaderButtonsService', require('./ViewHeaderButtonsService.js'))
  .directive('dynamicButton', require('./DynamicButtonDirective.js'))
  .directive('dynamicButtonRegister', require('./DynamicButtonRegisterDirective.js'))*/;


// WEBPACK FOOTER //
// ./src/js/core-utilities/dynamic-header-buttons/index.js